import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import postRequest from "util/APIHelperPost";

export const getDependentsDetails = async (employeeId) => {
  const { payload } = await getRequest(`${baseUrl}/employees/${employeeId}/dependants`);
  if (payload?.error) {
    throw new Error(payload?.error[0]?.description || "Failed to fetch dependents details");
  }
  return payload;
};

export const setDependentsDetails = async (employeeId, dependentsData) => {
  const request = `${baseUrl}/employees/${employeeId}/dependants`;
  const { payload } = await postRequest(request, JSON.stringify(dependentsData));
  if (payload?.error) {
    throw new Error(payload?.error[0]?.description || "Failed to set dependents details");
  }
  return payload;
};
